import React, { useCallback } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useNavigate } from '@tanstack/react-router';



const ClientChartsTableRow = (props) => {
	const id = props.row.visit_id,
		  navigate = useNavigate();

	const handleNavigate = useCallback(() => {
		navigate({ to: `/chart/${id}` });
	}, [ navigate, id ]);


	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
			onClick={handleNavigate}
		/>
	);
};


export default ClientChartsTableRow;